import { CHART_COLORS } from "./chartjsUtils"

export function getQuarters(datasets: any[]) {
  const quarters = Object.keys(datasets[0])
    .filter((key) => key.startsWith("Q"))
    .sort((a, b) => {
      // Extract year and quarter from strings
      const [, quarterA, yearA] = a.match(/Q(\d+) (\d+)/) ?? []
      const [, quarterB, yearB] = b.match(/Q(\d+) (\d+)/) ?? []

      // Compare years first
      if (yearA !== yearB) {
        return parseInt(yearA) - parseInt(yearB)
      }

      // If years are the same, compare quarters
      return parseInt(quarterA) - parseInt(quarterB)
    })

  return quarters
}

export function getColor(location: string, regional?: boolean) {
  if (regional) {
    if (location === "NSW") return CHART_COLORS["Regional / NSW"]
    if (location === "VIC") return CHART_COLORS["Regional / VIC"]
    if (location === "QLD") return CHART_COLORS["Regional / QLD"]
    if (location === "SA") return CHART_COLORS["Regional / SA"]
    if (location === "WA") return CHART_COLORS["Regional / WA"]
    if (location === "TAS") return CHART_COLORS["Regional / TAS"]
    if (location === "NT") return CHART_COLORS["Regional / NT"]

    return CHART_COLORS["Regional / National"]
  }

  if (location === "NSW") return CHART_COLORS["Red / NSW"]
  if (location === "VIC") return CHART_COLORS["Purple / VIC"]
  if (location === "QLD") return CHART_COLORS["Green / QLD"]
  if (location === "SA") return CHART_COLORS["Pink / SA"]
  if (location === "WA") return CHART_COLORS["Orange / WA"]
  if (location === "TAS") return CHART_COLORS["Blue / TAS"]
  if (location === "NT") return CHART_COLORS["Yellow / NT"]
  if (location === "ACT") return CHART_COLORS["Cyan / ACT"]

  return CHART_COLORS["Grey / National"]
}

export function getShortText(location: string) {
  if (location === "Sydney") return "SYD"
  if (location === "Wagga Wagga") return "WAG"
  if (location === "Melbourne") return "MEL"
  if (location === "Geelong") return "GEE"
  if (location === "Brisbane") return "BRI"
  if (location === "Townsville") return "TOW"
  if (location === "Perth") return "PER"
  if (location === "Bunbury") return "BUN"
  if (location === "Adelaide") return "ADE"
  if (location === "Mount Gambier") return "MOU"
  if (location === "Hobart") return "HOB"
  if (location === "Launceston") return "LAU"
  if (location === "Darwin") return "DAR"
  if (location === "Alice Springs") return "ALI"
  if (location === "Canberra") return "CAN"
  return ""
}

export function numberWithCommas(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

export function round(num: number, precision: number) {
  var base = 10 ** precision
  return (Math.round(num * base) / base).toFixed(precision)
}
